import React from 'react';

import { LoadingType } from 'prequalificationV2/actions';
import Loader from 'components/Loader';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import Section from 'prequalificationV2/components/LoanPortal/Sections/Section';
import EmploymentsInformation from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/EmploymentInformation/EmploymentInformation';
import { BorrowerRole } from 'enums/BorrowerRole';
import ContractorInformation from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/ContractorInformation/ContractorInformation';
import { DashboardTabName } from 'enums/DashboardTabName';
import styles from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/InformationTabs.module.scss';
import {
  getIsEmploymentSectionCompleted,
  getMissingEmploymentInformation,
} from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.utils';
import MissingEmploymentInformation from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/MissingEmploymentInformation/MissingEmploymentInformation';

const AdditionalInformationTab = () => {
  const loading = useAppSelector(
    (state) => state.loading[`${LoadingType.RequiredInformationUpdating}${DashboardTabName.AdditionalInformation}`],
  );
  const { variables: applicationVariables, dashboardAdditionalInfo } = useAppSelector((state) => state.application);
  const additionalTabProps = dashboardAdditionalInfo!;
  const isMissingEmploymentInformationRequired = additionalTabProps.isMissingEmploymentInformationRequired;

  return loading ? (
    <Loader />
  ) : (
    <div className={styles.requiredInformationContainer}>
      <Section
        title={`${applicationVariables?.borrower_first_name}'s Employment Information`}
        subSectionStates={[
          {
            isExist: isMissingEmploymentInformationRequired
              ? !!getMissingEmploymentInformation(additionalTabProps, BorrowerRole.Borrower).length
              : additionalTabProps.isBorrowerCurrentEmploymentsRequired ||
                additionalTabProps.isPartialBorrowerCurrentEmploymentsRequired ||
                additionalTabProps.isBorrowerPreviousEmploymentRequired ||
                additionalTabProps.isBorrowerEmploymentStatusInformationRequired,
            isCompleted: getIsEmploymentSectionCompleted(additionalTabProps, BorrowerRole.Borrower),
          },
        ]}
      >
        {isMissingEmploymentInformationRequired ? (
          <MissingEmploymentInformation borrowerType={BorrowerRole.Borrower} />
        ) : (
          <EmploymentsInformation borrowerType={BorrowerRole.Borrower} />
        )}
      </Section>
      <Section
        title={`${applicationVariables?.coborrower_first_name}'s Employment Information`}
        subSectionStates={[
          {
            isExist: isMissingEmploymentInformationRequired
              ? !!getMissingEmploymentInformation(additionalTabProps, BorrowerRole.CoBorrower).length
              : additionalTabProps.isCoBorrowerCurrentEmploymentsRequired ||
                additionalTabProps.isPartialCoBorrowerCurrentEmploymentsRequired ||
                additionalTabProps.isCoBorrowerPreviousEmploymentRequired ||
                additionalTabProps.isCoBorrowerEmploymentStatusInformationRequired,
            isCompleted: getIsEmploymentSectionCompleted(additionalTabProps, BorrowerRole.CoBorrower),
          },
        ]}
      >
        {isMissingEmploymentInformationRequired ? (
          <MissingEmploymentInformation borrowerType={BorrowerRole.CoBorrower} />
        ) : (
          <EmploymentsInformation borrowerType={BorrowerRole.CoBorrower} />
        )}
      </Section>
      <Section
        title={'Contractor Information'}
        subSectionStates={[
          {
            isExist: !isMissingEmploymentInformationRequired && additionalTabProps.isContractorEmploymentRequired,
            isCompleted: additionalTabProps.isContractorEmploymentCompleted,
          },
        ]}
      >
        <ContractorInformation />
      </Section>
    </div>
  );
};

export default AdditionalInformationTab;
